import { Injectable } from '@angular/core';
import { ConfigService } from '../common/config.service';
import { HttpClient, HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class BookingService {

  constructor(
    private configServ: ConfigService,
    private http: HttpClient
  ) { }

  getAppSettings() {
    return this.http.get<any>(
      `${this.configServ.apiRoutes.APP_SETTINGS}`,
    )
  }

  getProtectedAppSettings() {
    return this.http.get<any>(
      `${this.configServ.apiRoutes.PROTECTED_APP_SETTINGS}`,
    )
  }

  getServiceBrand(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.SERVICE_BRANDS}`,
      payload
    )
  }
  getbrandProducts(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.BRAND_PRODUCTS}`,
      payload
    )
  }
  getCardList() {
    return this.http.get<any>(
      `${this.configServ.apiRoutes.GETCARDLIST}`
    )
  }
  getUnreadChatCountPerOrder() {
    return this.http.get<any>(
      `${this.configServ.apiRoutes.ORDER_UNREAD_CHAT_COUNT}`
    )
  }
  addCard(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.ADDCARD}`,
      payload
    )
  }
  removeCard(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.REMOVECARD}`,
      payload
    )
  }

  checkPromocode(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.CHECK_PROMO_CODE}`,
      payload
    )
  }

  serviceRequestMakeOrder(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.SERVICE_REQUEST_MAKE_ORDER}`,
      payload
    )
  }
  serviceRequestMakeOrderMultiple(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.SERVICE_REQUEST_MAKE_ORDER_MULTIPLE}`,
      payload
    )
  }
  socketTestApi(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.SOCKET_TEST_API}`,
      payload
    )
  }

  orderOngoing() {
    return this.http.post<any>(
      this.configServ.apiRoutes.ORDER_ONGOING_CHECK,
      {}
    );
  }

  acceptOrderWithoutHelper(data: any) {
    return this.http.post<any>(this.configServ.apiRoutes.ACCEPT_ORDER_WITHOUT_HELPER, data);
  }

  serviceTip(payload: any) {
    return this.http.post<any>(
      this.configServ.apiRoutes.ORDER_TIP,
      payload
    );
  }

  placeAutocomplete(payload: any) {
    return this.http.post<any>(
      this.configServ.apiRoutes.PLACE_AUTOCOMPLETE,
      payload
    );
  }

  fetchOldChat(payload: any) {
    const params = new HttpParams({ fromObject: payload });
    return this.http.get<any>(
      this.configServ.apiRoutes.ORDER_CHAT,
      { params }
    );
  }

  sendMessage(payload: any) {
    const params = new HttpParams({ fromObject: payload });
    return this.http.post<any>(
      this.configServ.apiRoutes.SEND_MESSAGE,
      payload
    );
  }

  fetchOldHelperChat(payload: any) {
    const params = new HttpParams({ fromObject: payload });
    return this.http.get<any>(
      this.configServ.apiRoutes.GET_CHAT_FOR_HELPER,
      { params }
    );
  }
  sendHelperMessage(payload: any) {
    const params = new HttpParams({ fromObject: payload });
    return this.http.post<any>(
      this.configServ.apiRoutes.SEND_MESSAGE_TO_HELPER,
      payload
    );
  }
  serviceRequestforOnlyHelperOrder(payload: any) {
    return this.http.post<any>(
      `${this.configServ.apiRoutes.SERVICE_REQUEST_MAKE_ORDER_FOR_ONLY_HELPER}`,
      payload
    )
  }

   serviceTipForHelper(payload: any) {
    return this.http.post<any>(
      this.configServ.apiRoutes.ORDER_TIP_FOR_HELPER,
      payload
    );
  }

}
